import { render, staticRenderFns } from "./pengeluaran_himbauan.vue?vue&type=template&id=4bb0b5bb&"
import script from "./pengeluaran_himbauan.vue?vue&type=script&lang=js&"
export * from "./pengeluaran_himbauan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports